<template>
    <div class="conter">
        <div class="currency_suggest">
            <div class="titel">
                <span>同城经典案例</span>
            </div>
            <div>
                <div class="case_li" v-for="(item, index) in arrRanks" :key="index">
                    <p>
                        {{ item.type }}<span>|</span>{{ item.city + item.community_name + "项目案例" }}
                    </p>
                    <div class="attr">
                        <div class="attr-left">
                            <p>{{ item.house_area }}</p>
                            <p>{{ item.house_cate || "暂无" }}</p>
                        </div>
                        <div class="attr-right">
                            <img src="@/assets/images/ant/map/watch.png" alt="" />
                            <span>{{ item.views || item.real_views }}</span>
                        </div>
                    </div>
                    <div class="pic-list">
                        <div class="pic-item" v-for="(imgItem, imgIndex) in item.images" :key="imgIndex">
                            <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2" />
                        </div>
                    </div>
                    <div :class="['state-icon', stateStyle(item.state)]"></div>
                </div>
            </div>
            <div class="map_img">
                <img src="@/assets/images/antV2/scheme/map_icon.png" alt="" />
                <div class="btn">查看更多</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        arrRanks: {
            type: Array,
            default: false,
        },
    },
    data() {
        const vm = this;
        return {
        }
    },
    computed: {

    },
    methods: {
        stateStyle(state) {
            let className = "";
            switch (Number(state)) {
                case 1:
                    className = "yqy";
                    break;
                case 2:
                    className = "sgz";
                    break;
                case 3:
                    className = "ywg";
                    break;
            }
            return className;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>